var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "humbleicons:refresh"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M50 50.0002V37.5002H37.5M10.155 32.5002C10.6783 36.6567 12.4935 40.544 15.3444 43.6136C18.1953 46.6832 21.938 48.7803 26.0445 49.6089C30.1511 50.4375 34.4141 49.9558 38.2323 48.2318C42.0504 46.5078 45.2309 43.6286 47.325 40.0002",
    stroke: "var(--stroke-0, #99B3D3)",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 9.99996V22.5H22.5M49.845 27.5C49.3217 23.3435 47.5065 19.4562 44.6556 16.3866C41.8047 13.3169 38.062 11.2199 33.9555 10.3913C29.8489 9.56267 25.5859 10.0443 21.7677 11.7683C17.9496 13.4923 14.7691 16.3716 12.675 20",
    stroke: "var(--stroke-0, #004192)",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon-refresh.95ddba8cfa4cbceab6fef15436588bd8.svg";
export { ForwardRef as ReactComponent };